import { Language } from '../types/language';

const LOCALE_PATHS: Language[] = ['en', 'ja', 'cn'];

export const getLocaleFromPathname = (pathname: string): Language => {
  const segments = pathname.split('/').filter(Boolean);
  const basename = (process.env.PUBLIC_URL || '/').replace(/\/$/, '');
  const basenameSegments = basename.split('/').filter(Boolean);

  let relativeSegments = segments;
  if (
    basenameSegments.length > 0 &&
    segments.slice(0, basenameSegments.length).join('/') === basenameSegments.join('/')
  ) {
    relativeSegments = segments.slice(basenameSegments.length);
  }

  const first = relativeSegments[0];
  if (first && LOCALE_PATHS.includes(first as Language)) {
    return first as Language;
  }
  return 'ko';
};

export const getLocalePath = (language: Language): string => {
  if (language === 'ko') {
    return '/';
  }
  return `/${language}/`;
};

export const getLocaleHref = (language: Language): string => {
  const basename = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const path = getLocalePath(language);
  if (path === '/') {
    return `${basename}/`;
  }
  return `${basename}${path}`;
};
